import { ovl, SYSConfig } from "./"
import { SessionUpdate } from "./global/globalapi"
import {
  isMobile,
  isTouch,
  logout,
  stringifyReplacer,
  SYSSeqId,
  T,
} from "./global/globals"
import { DialogModal } from "./library/dialog/dialogapi"
import type { SnackType } from "./library/snack/snack"
import { SnackAdd } from "./library/snackapi"
import { SYSTOTPFields } from "../ovlsyscomponents/systotp01/features/formfields"
import { _ProcessReturnType } from "./library/longrunningprocesstracker/longrunningprocesstracker"

export let lastNoServerConnectionMsg: number

export const postRequest = async (
  url,
  data,
  isBlob?: boolean,
  suppressFeedbackSnack?: boolean,
  customTimeoutMs?: number,
  authCookieCheck?: boolean
  //indicatorOptions?: IndicatorOptions
) => {
  return await ovlFetch(
    url,
    data,
    "POST",
    isBlob,
    suppressFeedbackSnack,
    customTimeoutMs,
    false

    //indicatorOptions
  )
}

export const postFormDataRequest = async (
  url,
  data
  //indicatorOptions?: IndicatorOptions
) => {
  return await ovlFetch(
    url,
    data,
    "POST",
    false,
    false,
    -1,
    true
    //indicatorOptions
  )
}

//export type AssetDisplayMode = "Table" | "Edit"

// now when used for the fetch stuff we need an extended AssetType
// export const getAssetRequest = async (
//   url,
//   data: AssetRequestParams,
//   isBlob?: boolean,
//   suppressFeedbackSnack?: boolean
//   //indicatorOptions?: IndicatorOptions
// ) => {
//   return await ovlFetch(
//     url,
//     data,
//     "GET",
//     isBlob,
//     suppressFeedbackSnack,
//     -1,
//     false
//     //indicatorOptions
//   )
// }

export const getRequest = async (
  url,
  data: any,
  isBlob?: boolean,
  suppressFeedbackSnack?: boolean
  //indicatorOptions?: IndicatorOptions
) => {
  return await ovlFetch(
    url,
    data,
    "GET",
    isBlob,
    suppressFeedbackSnack,
    -1,
    false
    //indicatorOptions
  )
}

let lastAppNoServerConnectionTimestamp = 0
let lastAppReloginTimestamp = 0

export type FetchExceptionType = {
  status: number
  message: string
  type: string
  snacked?: boolean
  suppressFeedbackSnack?: boolean
}

export class FetchException extends Error {
  status: number
  type: string
  snacked: boolean
  suppressFeedbackSnack: boolean

  constructor(message: FetchExceptionType) {
    super(message.message)
    this.name = "FetchException"
    this.status = message.status
    this.type = message.type
    this.snacked = message.snacked === true
    this.suppressFeedbackSnack = message.suppressFeedbackSnack === true

    // Restore prototype chain for compatibility
    Object.setPrototypeOf(this, FetchException.prototype)
  }
}

export type SYSFetchResult = {
  status: number
  data: any
  headers: any
  message: string
  type: string
  TOTPCanceled?: boolean
}

export type SYSPreconditionRequired = {
  RequestKey: string
  Message: string
  Data: any
  ValidForDays: number
  Type: "TOTPLogin" | "TOTPPwChange"
}

export const ovlFetch = async (
  url,
  data,
  method: string,
  isBlob?: boolean,
  suppressFeedbackSnack?: boolean,
  customTimeoutMs?: number,
  isFormData?: boolean,
  isAuthCheck?: boolean,
  // if fromprocess is true then error Snacks will be handled there
  process?: _ProcessReturnType
  //indicatorOptions?: IndicatorOptions
): Promise<SYSFetchResult> => {
  let res
  let snackMessage = ""
  let type = ""
  let snackMessageType: SnackType = "Information"
  let reqOptions
  let timer
  let state = ovl.getState()
  let isApiAccess = url.indexOf(state.ovl.apiUrl) > -1
  let thrownError: any = undefined
  //let token = state.ovl.session.Token
  try {
    //ovl.getActions().ovl.indicator.SetIndicatorOpen(indicatorOptions)
    // Create request to api service

    reqOptions = {
      method,
      headers: {},
      signal: undefined,
    }

    let headers = {}
    if (method === "POST" && !isFormData) {
      let contentType = "application/json"
      reqOptions.headers["Content-Type"] = contentType
    }
    let user = state.ovl.user
    if (state.ovl.app.clientId) {
      reqOptions.headers["X-Ovl-Client-Id"] = state.ovl.app.clientId
    }
    // if (SYSConfig.fetch.authMode === "token" && user && token) {
    //   reqOptions.headers["itfprt"] = token
    // } else if (SYSConfig.fetch.authMode === "jwtToken" && user && token) {
    //   reqOptions.headers["Authorization"] = "Bearer " + token
    // } else if (SYSConfig.fetch.authMode === "cookie") {
    reqOptions.credentials = "include"
    //}

    if (url.indexOf("ovlnocache") > -1) {
      reqOptions["Cache"] = "no-cache"
      headers["pragma"] = "no-cache"
    }

    if (isFormData) {
      reqOptions["body"] = data
    } else if (method === "POST") {
      reqOptions["body"] = JSON.stringify(data, stringifyReplacer)
    } else if (data) {
      if (typeof data !== "object") {
        throw new Error(
          "ovl fetch: Get Request Param need to be an flat Object"
        )
      }
      url = GetUrlWithParams(url, data)
    }

    // forced timeout only in offline mode...timeouts are normally handled by the browser itself
    // but we need to rely on a timeout in offline mode which works the same across browsers, hence the forced timeout
    if (SYSConfig.offline.enabled) {
      let timeOutMs = SYSConfig.fetch.timeout
      if (customTimeoutMs && customTimeoutMs > -1) {
        timeOutMs = customTimeoutMs
      }
      if (timeOutMs && timeOutMs > 0) {
        const controller = new AbortController()
        const { signal } = controller

        timer = setTimeout(() => {
          controller.abort()
        }, timeOutMs)

        reqOptions.signal = signal
      }
    }
    const req = await fetch(url, reqOptions)
    if (SYSConfig.offline.enabled) {
      clearTimeout(timer)
    }
    if (
      isApiAccess &&
      (!SYSConfig.offline.enabled || reqOptions.method === "POST")
    ) {
      ovl.getState().ovl.app.offline.api = false
    }

    // lets check if backend requests totp
    if (req.status === 428) {
      var pcond: SYSPreconditionRequired = await req.json()

      if (pcond.Type.startsWith("TOTP")) {
        var instance = SYSSeqId()
        let fields = JSON.parse(JSON.stringify(SYSTOTPFields))

        let data = {
          Language: pcond.Data?.Language,
          Type: pcond.Type,
          Message: pcond.Message,
          RequestKey: pcond.RequestKey,
          ValidForDays: pcond.ValidForDays,
        }
        if (pcond.Data) {
          data["SetupManualCode"] = pcond.Data.SetupManualCode
          data["SetupQrCodeImageUrl"] = pcond.Data.SetupQrCodeImageUrl
        }

        return await DialogModal("SYSTOTP", {
          data,
          instance,
          formsHandling: [
            {
              isConnectedToDialog: true,
              formType: "SYSTOTP",
              formId: instance,
              removeFormStateWhenClose: true,
              creation: {
                autoInitFormFields: fields,
                initialFocusFieldKey: "TOTPDigit1",
              },
            },
          ],
        })
      }
    }

    // with fetch we will have the repsonse status here on req object
    if (req.ok) {
      // ok all good
      // whenever there is a token change. save it to localStorage
      // let itfprttoken = req.headers.get("itfprttoken")
      // if (itfprttoken !== null) {
      //   await SessionUpdate("Token", itfprttoken)
      // }

      let itfprtsession = req.headers.get("itfprtsession")
      if (itfprtsession !== null) {
        let sessionObj = JSON.parse(itfprtsession)

        Object.keys(sessionObj).forEach((k) => {
          //@ts-ignore
          SessionUpdate(k, sessionObj[k])
        })
      }
      if (isBlob) {
        res = await req.blob()
      } else {
        const contentType = req.headers.get("content-type")

        if (contentType && contentType.indexOf("application/json") !== -1) {
          res = await req.json()
        }
      }
      let res0 = { res }
      //if (SYSConfig.fetch.useCompressed === true) {
      checkAllArrayPropertiesForCompressedAndUncompress(res0)
      //}
      snackMessageType = "Success"
      return {
        headers: req.headers,
        data: res0.res,
        status: req.status,
        message: "",
        type: "",
      }
    } else {
      if (req.status === 429) {
        // we are hitting ratelimit ourself
        // wait for window
        // we breathe for 10 secs because we have 10 secs fixed window on backend
        await new Promise((res) => setTimeout(res, 10000))

        return await ovlFetch(
          url,
          data,
          method,
          isBlob,
          suppressFeedbackSnack,
          customTimeoutMs,
          isFormData
        )
      } else if (req.status === 401) {
        if (url.endsWith("logout")) {
          location.reload()
        }
        let msg
        try {
          msg = await req.json()
        } catch {}
        let now = Date.now()
        if (now > lastAppReloginTimestamp + 5000 && !isAuthCheck) {
          lastAppReloginTimestamp = now
          SnackAdd(T("SYSLoginPleaseRelogin"))
        }
        await DialogModal("SYSLogin")
        if (isAuthCheck) {
          return
        }
        return await ovlFetch(
          url,
          data,
          method,
          isBlob,
          suppressFeedbackSnack,
          customTimeoutMs,
          isFormData
        )
      } else if (req.status === 413) {
        let message = T("SYSUploadTooBig")
        let snacked = false
        if (!process && !suppressFeedbackSnack) {
          SnackAdd(message, "Error")
          snacked = true
        }
        throw new FetchException({
          status: 413,
          message,
          type: "",
          snacked,
          suppressFeedbackSnack,
        })
      } else if (req.status === 404) {
        // well...  go to offline mode. We need it as well here (depends on the webserver...)
        if (isApiAccess) {
          ovl.getState().ovl.app.offline.api = true
        }
        let nfurl = url
        if (data && data.id1) {
          nfurl = data.id1
        }
        let message = T("SYSResourceNotFound", [nfurl])
        let snacked = false
        if (!SYSConfig.offline.enabled && !process && !suppressFeedbackSnack) {
          SnackAdd(message, "Error")
          snacked = true
        }
        throw new FetchException({
          status: 404,
          message,
          type: "",
          snacked,
          suppressFeedbackSnack,
        })
      } else if (req.status === 403) {
        let message = T("SYSNotAllowed")
        let snacked = false
        if (!process && !suppressFeedbackSnack) {
          SnackAdd(message, "Error")
          snacked = true
        }
        throw new FetchException({
          status: 403,
          message,
          type: "OvlResourceForbidden",
          snacked,
          suppressFeedbackSnack,
        })
      } else if (req.status === 400) {
        let msg = await req.json()
        let type = msg?.type || ""
        let message = msg?.message || req.statusText
        let snacked = false
        if (message && !type && !process && !suppressFeedbackSnack) {
          SnackAdd(message, "Error")
          snacked = true
        }
        throw new FetchException({
          status: 400,
          message,
          type,
          snacked,
          suppressFeedbackSnack,
        })
      } else if (req.status === 422) {
        let msg = await req.json()
        throw new FetchException({
          status: 422,
          message: msg.errormessage,
          type: msg.type || "",
          snacked: false, // Bypassed
          suppressFeedbackSnack,
        })
      } else {
        let msg = undefined
        try {
          msg = await req.json()
        } catch {
          // if there is no json result (eg. a 500 error throwed from server)
          // create a generic one
          msg = { message: "Server Error" }
        }
        let type = msg.type || ""
        let message = msg.message || "Server Error"
        let snacked = false
        if (message && !type && !process && !suppressFeedbackSnack) {
          SnackAdd(message, "Error")
          snacked = true
        }

        throw new FetchException({
          status: req.status,
          message,
          type,
          snacked,
          suppressFeedbackSnack,
        })
      }
    }
  } catch (err) {
    console.log("FetchException details:", {
      ...err,
      message: err?.message,
      stack: err?.stack,
    })
    if (err instanceof FetchException) {
      throw err
    }

    // connection error
    // well...  go to offline mode
    if (isApiAccess) {
      ovl.getState().ovl.app.offline.api = true
    }

    let state = ovl.getState()
    // don't display connection error msgs in offline mode and already logged in
    // instead use other indication (blinking offline stuff to signalize we are offline)
    let noServerConnectionMsg = "No Server Connection!"
    let snacked = false
    if (!SYSConfig.offline.enabled || !state.ovl.app.ready) {
      snacked = true
      let now = Date.now()
      if (now > lastAppNoServerConnectionTimestamp + 5000) {
        lastAppNoServerConnectionTimestamp = now
        setTimeout(() => {
          SnackAdd(noServerConnectionMsg, "Warning")
        }, 2000)
      }
    }
    throw new FetchException({
      status: 449,
      message: noServerConnectionMsg,
      type: "OvlServerOffline",
      snacked,
      suppressFeedbackSnack,
    })
  } finally {
    if (timer) {
      clearTimeout(timer)
    }
  }
}

const checkAllArrayPropertiesForCompressedAndUncompress = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (Array.isArray(obj[key])) {
        obj[key] = _uncompressAndMassageServerData(obj[key])
        checkAllArrayPropertiesForCompressedAndUncompress(obj[key])
      } else if (typeof obj[key] === "object") {
        checkAllArrayPropertiesForCompressedAndUncompress(obj[key])
      }
    }
  }
}

const _uncompressAndMassageServerData = (serverData: any[]): any[] => {
  if (serverData[1] !== undefined) {
    // there is more than 1 row check if first object.keys from second row is in first row

    // and it needs to be an array of objects
    // and first entriy object value needs to be string
    // if no its the compressed format
    if (
      typeof serverData[0] === "object" &&
      typeof Object.keys(serverData[0])[0] === "string" &&
      serverData[0][Object.keys(serverData[1])[0]] === undefined
    ) {
      // compressed format...
      // create a map with colIndex -> colName
      let colIndexToColName = new Map<string, string>()
      let rowFnBitMap = new Map<number, string>()
      Object.keys(serverData[0]).forEach((key) => {
        if (key.startsWith("_RowFn_")) {
          rowFnBitMap.set(serverData[0][key], key.replace("_RowFn_", ""))
        } else {
          colIndexToColName.set(serverData[0][key].toString(), key)
        }
      })

      // remove first row
      serverData.shift()
      let uncompressedData = serverData.map((row) => {
        let newRow = {}
        for (let key of colIndexToColName.keys()) {
          let colVal = row[key]
          if (colVal === undefined) {
            colVal = null
          }
          let colName = colIndexToColName.get(key)
          if (
            colName === "OvlSysSrvRowPermissions" &&
            typeof colVal === "number"
          ) {
            let rowFnPerms = {}
            for (let [bit, fnKey] of rowFnBitMap.entries()) {
              rowFnPerms[fnKey] = (colVal & bit) !== 0
            }
            colVal = {
              CanModify: (colVal & 1) !== 0,
              CanDelete: (colVal & 2) !== 0,
              CanCopy: (colVal & 4) !== 0,
              RowFnPermissions: rowFnPerms,
            }
          }
          if (newRow[colName] === undefined) {
            newRow[colName] = colVal
          }
        }
        return newRow
      })
      serverData = uncompressedData
    }
  }
  return serverData
}

export const GetUrlWithParams = (url: string, data: {}): string => {
  // encode data as url param
  const UrlCreator = window.URL || window.webkitURL
  var urlWithParams = new UrlCreator(url)
  Object.keys(data).forEach((k) => {
    urlWithParams.searchParams.append(k, data[k])
  })
  urlWithParams.searchParams.append(
    "v",
    ovl.getState().ovl.app.discCacheVersion.toString()
  )
  return urlWithParams.toString()
}
